
export const menuItems = [
    {
        label: "Main",
        isHeader: true,
        roles: ["*"],
    },
    {
        label: "Dashboard",
        icon: "mdi mdi-view-dashboard",
        link: "/dashboard",
        roles: ["*"],
    },
    {
        label: "Système (Admin)",
        isHeader: true,
        roles: ["super-admin", "admin", "support", "sales"],
        permissions: ["view-companies", "manage-companies", "view-sales-dashboard", "manage-plans", "manage-system-users", "manage-roles-permissions", "manage-subscriptions", "view-subscription-invoices", "manage-support", "manage-settings"]
    },
    {
        label: "Entreprises",
        icon: "mdi mdi-office-building",
        link: "/admin/companies",
        permissions: ["view-companies"]
    },
    {
        label: "Commercial (Leads)",
        icon: "mdi mdi-trending-up",
        link: "/admin/sales-dashboard",
        permissions: ["view-sales-dashboard"]
    },
    {
        label: "Plans d'Abonnement",
        icon: "mdi mdi-badge-account-horizontal",
        link: "/admin/plans",
        permissions: ["manage-plans"]
    },
    {
        label: "Équipe Admin",
        icon: "mdi mdi-account-star",
        link: "/admin/system-users",
        permissions: ["manage-system-users"]
    },
    {
        label: "Rôles & Permissions",
        icon: "mdi mdi-shield-check",
        permissions: ["manage-roles-permissions"],
        subItems: [
            { label: "Rôles", link: "/admin/roles" },
            { label: "Permissions", link: "/admin/permissions" },
        ]
    },
    {
        label: "Gestion Abonnements",
        icon: "mdi mdi-credit-card-check-outline",
        link: "/admin/subscriptions/pending",
        permissions: ["manage-subscriptions"]
    },
    {
        label: "Factures Abonnements",
        icon: "mdi mdi-file-document-outline",
        link: "/admin/invoices",
        permissions: ["view-subscription-invoices"]
    },
    {
        label: "Tickets de Support",
        icon: "mdi mdi-help-circle-outline",
        link: "/admin/tickets",
        permissions: ["manage-support"]
    },
    {
        label: "Paramètres Système",
        icon: "mdi mdi-cog-outline",
        link: "/admin/settings",
        permissions: ["manage-settings"]
    },
    {
        label: "CRM Entreprise",
        isHeader: true,
        permissions: ["manage-customers", "manage-suppliers", "manage-products", "manage-finance", "use-whatsapp", "view-reports", "manage-team", "manage-company-settings"]
    },
    {
        label: "Clients",
        icon: "mdi mdi-account-group",
        link: "/clients",
        permissions: ["manage-customers"]
    },
    {
        label: "Fournisseurs",
        icon: "mdi mdi-truck-delivery-outline",
        permissions: ["manage-suppliers"],
        subItems: [
            { label: "Liste Fournisseurs", link: "/suppliers" },
            { label: "Factures Fournisseurs", link: "/supplier-invoices" },
        ]
    },
    {
        label: "Catalogue & Stock",
        icon: "mdi mdi-package-variant",
        link: "/stock/products",
        permissions: ["manage-products"]
    },
    {
        label: "Finances",
        icon: "mdi mdi-cash-multiple",
        permissions: ["manage-finance"],
        subItems: [
            { label: "Devis", link: "/finance/quotes" },
            { label: "Factures", link: "/finance/invoices" },
            { label: "Paiements", link: "/payments" },
        ]
    },
    {
        label: "Chat",
        icon: "mdi mdi-message-text-outline",
        link: "/chat",
        permissions: ["access-chat"], // Fixed: used 'access-chat' for both if type matches
    },
    {
        label: "WhatsApp",
        icon: "mdi mdi-whatsapp",
        link: "/whatsapp",
        permissions: ["use-whatsapp", "manage-support"], // Super admins can see it too via manage-support/access-chat context? 
    },
    {
        label: "Reporting",
        icon: "mdi mdi-chart-bar",
        link: "/reports",
        permissions: ["view-reports"]
    },
    {
        label: "Équipe Interne",
        icon: "mdi mdi-account-multiple",
        link: "/team",
        permissions: ["manage-team"]
    },
    {
        label: "Paramètres Société",
        icon: "mdi mdi-briefcase-variant-outline",
        link: "/company-settings",
        permissions: ["manage-company-settings"]
    },
    {
        label: "SUPPORT & AIDE",
        isHeader: true,
        roles: ["*"]
    },
    {
        label: "Support Technique",
        icon: "mdi mdi-lifebuoy",
        link: "/support/tickets",
        roles: ["*"]
    }
];
